import React from 'react';
import './baseButton.css'; // Import the shared styles
import SquareCircle from '../../customLoader/SquareCircle';

/**
 * GreenButton Component
 * Renders a reusable green button with a sliding text animation on hover.
 *
 * @param {object} props - The component props.
 * @param {string} props.width - The CSS width value for the button (e.g., '140px', 'auto').
 * @param {string} props.firstText - The initial text displayed on the button.
 * @param {string} props.secondText - The text that slides in on hover.
 * @param {function} props.handleClick - The function to call when the button is clicked.
 * @param {boolean} props.loading - Optional. When true, shows a loader instead of text.
 */
const CustomGreenButton = ({ width, firstText, secondText, handleClick, loading = false, ...props }) => {
    return (
        // Apply base-button for common styles and button-green-style for specific green styling
        <button className='base-button button-green-style' style={{ width: width }} onClick={handleClick} {...props}>
            {loading ? (
                <div className="button-loader">
                    <SquareCircle />
                </div>
            ) : (
                <div className="button-text-container">
                    <p className="button-text-main" style={{ color: '#000000' }}>
                        {firstText}
                    </p>
                    <p className="button-text-hover" style={{ color: '#000000' }}>
                        {secondText}
                    </p>
                </div>
            )}
        </button>
    );
};

export default CustomGreenButton;
